import IconOptionsEnum from "../enums/IconOptionsEnum";

export const getColorByShippingStatusId = (statusId) => {
  switch (statusId) {
    case 11:
      return IconOptionsEnum.DELIVERED;
    case 12:
    case 13:
      return IconOptionsEnum.PENDING;
    default:
      return IconOptionsEnum.UNDELIVERED;
  }
}


export const getIconAndColor = (location) => {
  if (location.icon_type === "driver") {
    return IconOptionsEnum.DRIVER;
  } else if (location.icon_type === "package") {
    return getColorByShippingStatusId(location.status)
  }
  return IconOptionsEnum.DEFAULT;
};
